import React from 'react'

function Javascript() {
  return (
    <div>Javascript</div>
  )
}

export default Javascript